module.exports = __webpack_public_path__ + "assets/active-995a26.svg";